import { ZodiacGeminiIcon } from './ZodiacGeminiIcon';

/**
 * author: Michael Richins
 * id ECDB16AC-832D-446E-974E-9F99657685D0
 * name zodiac-gemini
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-gemini.svg
 * tags
 */
export const HoroscopeGeminiIcon = ZodiacGeminiIcon;
export default HoroscopeGeminiIcon